// src/lib/uuid.ts

export function generatePatientId(): string {
  return crypto.randomUUID();
}
